export default {
  'site.name': '韩漫网',
  'site.subtitle': '高质量韩国漫画在线阅读平台',
  'site.description': '在韩漫网，免费访问高质量韩国漫画在线阅读平台和最新漫画资源，内容新颖画质优良，是您探索韩漫的理想之地。',
  'nav.home': '首页',
  'nav.category': '分类浏览',
  'nav.about': '关于我们',
  'nav.search': '搜索漫画...',
  'hero.title': '探索韩国漫画的无限魅力',
  'hero.subtitle': '海量高质量韩漫资源，每日更新，免费在线阅读',
  'hero.cta': '开始阅读',
  'hero.browse': '浏览分类',
  'section.featured': '精选推荐',
  'section.trending': '热门排行',
  'section.latest': '最新更新',
  'section.categories': '分类浏览',
  'comic.chapters': '话',
  'comic.rating': '评分',
  'comic.views': '阅读',
  'comic.status.ongoing': '连载中',
  'comic.status.completed': '已完结',
  'comic.read': '开始阅读',
  'comic.continue': '继续阅读',
  'comic.author': '作者',
  'comic.tags': '标签',
  'comic.description': '作品简介',
  'comic.chapterList': '章节列表',
  'comic.related': '相关推荐',
  'comic.totalChapters': '共 {{count}} 话',
  'category.all': '全部漫画',
  'category.filter': '筛选分类',
  'category.comics': '部漫画',
  'breadcrumb.home': '首页',
  'about.title': '关于韩漫网',
  'about.brand': '品牌介绍',
  'about.reputation': '用户口碑',
  'about.contact': '联系我们',
  'about.brand.desc': '韩漫网成立于2024年，是国内领先的韩国漫画在线阅读平台。我们致力于为华语读者提供最新、最全、最高质量的韩国漫画资源。',
  'about.brand.mission': '我们的使命是让每一位漫画爱好者都能方便、快捷地获取优质的韩国漫画内容，享受沉浸式的阅读体验。',
  'about.brand.vision': '我们相信漫画是一种跨越语言与文化界限的艺术形式。韩漫网将持续引入更多优质作品，打造华语世界最受欢迎的韩漫阅读社区。',
  'about.contact.email': '联系邮箱',
  'about.contact.wechat': '官方微信',
  'about.contact.qq': 'QQ群',
  'about.contact.address': '公司地址',
  'about.contact.address.value': '北京市朝阳区望京SOHO T3-A座 2508室',
  'about.contact.email.value': 'contact@hanmanwang.com',
  'about.contact.wechat.value': 'HanManWang_Official',
  'about.contact.qq.value': '875629341',
  'footer.copyright': '© 2026 韩漫网 版权所有',
  'footer.privacy': '隐私政策',
  'footer.terms': '使用条款',
  'footer.dmca': 'DMCA声明',
  'footer.about': '关于我们',
  'footer.contact': '联系我们',
  'footer.slogan': '韩漫网 — 发现韩漫之美',
  'pagination.prev': '上一页',
  'pagination.next': '下一页',
  'pagination.page': '第 {{current}} / {{total}} 页',
  'search.placeholder': '输入漫画名称或作者...',
  'search.noResults': '未找到相关漫画',
  'backToTop': '回到顶部',
};